export default __webpack_public_path__ + "static/media/last-locs.f058611c.svg";